<template>
	<app-page>
		<app-tabs app :tabs="tabs">
			<template v-slot:tab-item="{ tab }">
				<app-tab-item :tab="tab" value="listings">
					<app-heading :title="`${market.name} Listings`" />
					<app-row>
						<app-cell>
							<input-button-group
								color="primary"
								mandatory
								:value="1"
								@change="onStatusChange"
							>
								<app-button no-margin small>Active</app-button>
								<app-button no-margin small>Pending</app-button>
							</input-button-group>
						</app-cell>
					</app-row>
					<app-row>
						<app-cell>
							<app-data-table
								:items="listings"
								:headers="headers"
								:total="count"
								:refresh.sync="refresh"
								:initial-state="tableState"
								search
								@search="onSearch"
								@update="fetchListings"
								sort-by="date"
								sort-desc
							>
								<template v-slot:date="{ item }">
									<span v-if="item.date">
										{{ item.date | date(market.timezone) }}
									</span>
									<span v-else class="warning--text">
										<i>TBD</i>
									</span>
								</template>
								<template v-slot:url="{ item }">
									<a :href="item.url" target="_blank">Link</a>
								</template>
								<template v-slot:actions="{ item }">
									<app-button-confirm
										color="success"
										icon="fa-check"
										table
										title="Approve listing"
										:description="`Are you sure you want to approve listing <b>${item.title}<b/>?`"
										label-confirm="Approve"
										@click="onApprove(item._id)"
									>
										Approve
									</app-button-confirm>
									<app-button-confirm
										color="error"
										icon="fa-check"
										table
										title="Decline listing"
										:description="`Are you sure you want to decline listing <b>${item.title}<b/>?`"
										label-confirm="Decline"
										@click="onDecline(item._id)"
									>
										Decline
									</app-button-confirm>
								</template>
							</app-data-table>
						</app-cell>
					</app-row>
				</app-tab-item>
			</template>
		</app-tabs>
	</app-page>
</template>

<script>
import { filters, search, tableState } from '@/mixins'
import { marketMathTabs } from '@/datasources/tabs'

export default {
	mixins: [filters, search, tableState],
	data() {
		return {
			market: {
				name: '',
				timezone: 'UTC',
			},
			listings: [],
			count: -1,
			refresh: false,
			tabs: [],
			headers: [{
				text: 'Link',
				value: 'url',
				sortable: false,
			}, {
				text: 'Published On',
				value: 'date',
				sortable: true,
			}, {
				text: 'Title',
				value: 'title',
				sortable: true,
			}, {
				text: 'Address',
				value: 'address',
				sortable: true,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				width: '25%',
				sortable: false,
			}],
			defaultTableSort: '-date',
		}
	},
	computed: {
		marketId() {
			return this.$route.params.market
		},
	},
	async mounted() {
		this.market = await this.$ravello.graphql('market', this.marketId)
			.fields(['name, timezone'])
			.query()

		this.tabs = marketMathTabs(this.marketId, 'pending')
	},
	methods: {
		async fetchListings(pagination) {
			this.updateTableState(pagination)

			const request = this.$ravello.graphql('pendinglistings')
				.parent(this.$ravello.graphql('market', this.marketId))
				.include(this.$ravello.graphql('market_city').fields(['name']))
				.fields([
					'_id',
					'date',
					'title',
					'address',
					'url',
				])
				.filter('status', 0)
				.fromPagination(pagination)

			if (this.count === -1 && !this.searchString) {
				request.count('count')
			}

			if (this.searchText) {
				request.search(this.searchText)
			}
			try {
				this.listings = await request.query()

				if (this.searchText) {
					this.count = this.listings.length
				}
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},

		async onApprove(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.marketId)
					.to('pendinglistings')
					.to(id)
					.to('approve')
					.create()
				this.refresh = true

				this.$notifications.pushAlert('success', 'Listing approved!')
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},

		async onDecline(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.marketId)
					.to('pendinglistings')
					.to(id)
					.to('decline')
					.create()
				this.refresh = true

				this.$notifications.pushAlert('success', 'Listing declined!')
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},

		onStatusChange(value) {
			switch (value) {
			case 0:
				this.$router.push({ name: 'market-listings' })
				break
			default:
			}
		},
	},
}
</script>
